import React, { useState } from "react";
import "../../styles/intake.css";

const serviceOptions = [
  "Botox /Dysport",
  "Dermal Fillers",
  "Microneedling",
  "Chemical Peels",
  "Laser Hair Removal",
  "IPL Photofacial",
  "Laser Skin Resurfacing",
  "Hydrafacial",
  "Facials",
  "PRP Therapy",
  "Kybella",
  "CoolSculpting / Body Contouring",
  "Skin Tightening (RF, HIFU)",
  "IV Therapy",
  "Vitamin Injections",
  "Medical Weight Loss",
  "Hormone Therapy",
  "Acne Treatment",
  "Rosacea Treatment",
  "Melasma Treatment",
  "Skin Tag / Mole Removal",
  "Stretch Mark Reduction",
  "Scar Treatment",
  "Tattoo Removal",
  "Eyebrow Microblading",
  "Lip Blush / Cosmetic Tattooing",
  "Lash Lift / Extensions",
  "Medical Grade Skincare Consultation",
  "PDO Threads",
  "Sclerotherapy",
];

export default function ServiceSelector({ selected, setSelected, single = false }) {
  const [open, setOpen] = useState(false);

  const toggleService = (service) => {
    if (single) {
      // For single select, replace entire selection
      setSelected(service);
      setOpen(false); // auto-close dropdown
    } else {
      // For multi select
      if (selected.includes(service)) {
        setSelected(selected.filter((s) => s !== service));
      } else {
        setSelected([...selected, service]);
      }
    }
  };

  const isSelected = (service) => {
    return single ? selected === service : selected.includes(service);
  };

  return (
    <div className="dropdown-wrapper">
      <div className="dropdown-header" onClick={() => setOpen(!open)}>
        {single
          ? selected || "Select service..."
          : selected.length > 0
            ? selected.join(", ")
            : "Select services..."}
        <span className="arrow">{open ? "▲" : "▼"}</span>
      </div>

      {open && (
        <div className="dropdown-menu">
          {serviceOptions.map((service) => (
            <label key={service} className="dropdown-item">
              <input
                type={single ? "radio" : "checkbox"}
                name={single ? "singleService" : undefined}
                checked={isSelected(service)}
                onChange={() => toggleService(service)}
              />
              {service}
            </label>
          ))}
        </div>
      )}
    </div>
  );
}
